export default {
  env: 'production',
  full_env_name: 'suitup_law_production',
  files_url: 'https://files.suitup.co.il/',
  hr_email: 'office@suitup.io',
  operation_email: 'office@suitup.io,reut@suitup.io',
  background_theme: '/suitup_background_theme.png',
  owners_without_toast: ['מיכל'],
  owners: [
    {
      name: 'נעם',
      phone_number: '053-476-6228',
      color: '#fdca30'
    },
    {
      name: 'רעות',
      phone_number: '050-778-9772',
      color: '#ffc168'
    },
    {
      name: 'זיו',
      phone_number: '053-553-6172',
      color: '#ee70a6'
    },
    {
      name: 'ליאב',
      phone_number: '054-648-9367',
      color: '#6d6e70'
    },
    {
      name: 'מאיה',
      phone_number: '053-471-6414',
      color: '#8e43e7'
    },
    {
      name: 'מעין',
      phone_number: '053-442-8900',
      color: '#05cc47'
    },
    {
      name: 'עדי',
      phone_number: '053-476-6228',
      color: '#006837'
    },
    {
      name: 'הילה',
      phone_number: '050-671-1675',
      color: '#ee4f4f'
    },
    {
      name: 'הראל',
      phone_number: '050-639-9920',
      color: '#6d6e70'
    },
    {
      name: 'שביט',
      phone_number: '053-356-7688',
      color: '#fdca30'
    },
    {
      name: 'מערכת',
      phone_number: '050-639-9920',
      color: '#49c0b6'
    },
    {
      name: 'מיתר',
      phone_number: '053-553-6172',
      color: '#2dde98'
    },
    {
      name: 'נינה',
      phone_number: '053-446-2801',
      color: '#ed008c'
    },
    {
      name: 'פז',
      phone_number: '051-241-0744',
      color: '#8e43e7'
    },
    {
      name: 'עפרי',
      phone_number: '051-566-7299',
      color: '#fdca30'
    },
    {
      name: 'יובל',
      phone_number: '051-264-0834',
      color: '#fdca30'
    }
  ]
}
